// @flow
import { fetchPatientData } from './patientActions';
import { SERVER_ADDRESS, fetchPost } from '../util/actionsUtil';

export const ADD_EXTERNAL_REPORT_LOADING = 'ADD_EXTERNAL_REPORT_LOADING';
export const ADD_EXTERNAL_REPORT_SUCCESS = 'ADD_EXTERNAL_REPORT_SUCCESS';
export const ADD_EXTERNAL_REPORT_ERROR = 'ADD_EXTERNAL_REPORT_ERROR';
export const UPDATE_EXTERNAL_REPORT_LOADING = 'UPDATE_EXTERNAL_REPORT_LOADING';
export const UPDATE_EXTERNAL_REPORT_SUCCESS = 'UPDATE_EXTERNAL_REPORT_SUCCESS';
export const UPDATE_EXTERNAL_REPORT_ERROR = 'UPDATE_EXTERNAL_REPORT_ERROR';
export const DELETE_EXTERNAL_REPORT_LOADING = 'DELETE_EXTERNAL_REPORT_LOADING';
export const DELETE_EXTERNAL_REPORT_SUCCESS = 'DELETE_EXTERNAL_REPORT_SUCCESS';
export const DELETE_EXTERNAL_REPORT_ERROR = 'DELETE_EXTERNAL_REPORT_ERROR';

function addReport(patientId: string, report: Object, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/externalReports/add${type}`,
      {
        ...report,
        patientId,
      },
      (data) => {
        dispatch({
          type: ADD_EXTERNAL_REPORT_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_EXTERNAL_REPORT_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_EXTERNAL_REPORT_LOADING,
    });
  });
}

function updateReport(patientId: string, report: Object, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/externalReports/update${type}`,
      {
        ...report,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_EXTERNAL_REPORT_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_EXTERNAL_REPORT_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_EXTERNAL_REPORT_LOADING,
    });
  });
}

function deleteReport(patientId: string, reportId: string, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/externalReports/delete${type}`,
      {
        reportId,
        patientId,
      },
      (data) => {
        dispatch({
          type: DELETE_EXTERNAL_REPORT_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: DELETE_EXTERNAL_REPORT_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_EXTERNAL_REPORT_LOADING,
    });
  });
}

export function addDoctorNote(patientId: string, note: Object) {
  return addReport(patientId, note, 'DoctorNote');
}
export function updateDoctorNote(patientId: string, note: Object) {
  return updateReport(patientId, note, 'DoctorNote');
}

// written manually because of noteId instead of reportId
export function deleteDoctorNote(patientId: string, noteId: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/externalReports/deleteDoctorNote`,
      {
        noteId,
        patientId,
      },
      (data) => {
        dispatch({
          type: DELETE_EXTERNAL_REPORT_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: DELETE_EXTERNAL_REPORT_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_EXTERNAL_REPORT_LOADING,
    });
  });
}

export function addLabResult(patientId: string, report: Object) {
  return addReport(patientId, report, 'LabResult');
}
export function updateLabResult(patientId: string, report: Object) {
  return updateReport(patientId, report, 'LabResult');
}
export function deleteLabResult(patientId: string, reportId: string) {
  return deleteReport(patientId, reportId, 'LabResult');
}

export function addXray(patientId: string, report: Object) {
  return addReport(patientId, report, 'Xray');
}
export function updateXray(patientId: string, report: Object) {
  return updateReport(patientId, report, 'Xray');
}
export function deleteXray(patientId: string, reportId: string) {
  return deleteReport(patientId, reportId, 'Xray');
}

export function addCTScan(patientId: string, report: Object) {
  return addReport(patientId, report, 'CTScan');
}
export function updateCTScan(patientId: string, report: Object) {
  return updateReport(patientId, report, 'CTScan');
}
export function deleteCTScan(patientId: string, reportId: string) {
  return deleteReport(patientId, reportId, 'CTScan');
}

export function addUltrasound(patientId: string, report: Object) {
  return addReport(patientId, report, 'Ultrasound');
}
export function updateUltrasound(patientId: string, report: Object) {
  return updateReport(patientId, report, 'Ultrasound');
}
export function deleteUltrasound(patientId: string, reportId: string) {
  return deleteReport(patientId, reportId, 'Ultrasound');
}

export function addOtherImagingReport(patientId: string, report: Object) {
  return addReport(patientId, report, 'OtherImagingReport');
}
export function updateOtherImagingReport(patientId: string, report: Object) {
  return updateReport(patientId, report, 'OtherImagingReport');
}
export function deleteOtherImagingReport(patientId: string, reportId: string) {
  return deleteReport(patientId, reportId, 'OtherImagingReport');
}

export function addSocialWork(patientId: string, report: Object) {
  return addReport(patientId, report, 'SocialWork');
}
export function updateSocialWork(patientId: string, report: Object) {
  return updateReport(patientId, report, 'SocialWork');
}
export function deleteSocialWork(patientId: string, reportId: string) {
  return deleteReport(patientId, reportId, 'SocialWork');
}

export function addMiscReport(patientId: string, report: Object) {
  return addReport(patientId, report, 'MiscReport');
}
export function updateMiscReport(patientId: string, report: Object) {
  return updateReport(patientId, report, 'MiscReport');
}
export function deleteMiscReport(patientId: string, reportId: string) {
  return deleteReport(patientId, reportId, 'MiscReport');
}



// WEBPACK FOOTER //
// ./client/src/actions/externalReportsActions.js